export enum LogSeverity {
  Info = 0,
  Debug = 1,
  Warning = 2,
  Error = 3,
}
